<template>
	<div class="user-nav">
		<div class="user-logo">
			<a href="http://www.beiyv.com" target="_blank">
				<img src="http://www.beiyv.com/static/img/logo.png">
			</a>
		</div>
		<div class="user-menu">
			<dl></dl>
			<dl v-for="item in navData" @click="toRouter(item)" :class="navIndex==item.id?'unon':''" v-if="item.show">
				<dt v-if="item.istop" style="color: #cc2535;">
					<i :class="item.icon"></i>
				</dt>
				<dt v-else>
					<i :class="item.icon"></i>
				</dt>
				<dd v-if="item.istop" style="color: #cc2535;">
					{{item.name}}
				</dd>
				<dd v-else>
					{{item.name}}
				</dd>
			</dl>
			<dl></dl>
		</div>
		<div class="user-logout" @click="logout">
			<i class="el-icon-upload2"></i>
			退出登录
		</div>
	</div>
</template>

<script>
	import api from '@/api/api'
	export default{
		data(){
			return{
				navIndex:1,
				navData:[{
					id:1,name:'创作中心',icon:'el-icon-discount',lk:'/member',show:true,istop:false
				},{
					id:2,name:'我的提示词',icon:'el-icon-edit-outline',lk:'/word',show:true,istop:false
				},{
					id:3,name:'我的主页',icon:'el-icon-monitor',lk:'/myhome',show:false,istop:false
				},{
					id:4,name:'我的资料',icon:'el-icon-news',lk:'/set',show:true,istop:false
				},{
					id:5,name:'我的收藏',icon:'el-icon-star-off',lk:'/favorite',show:true,istop:false
				},{
					id:6,name:'网文速览',icon:'el-icon-milk-tea',lk:'/novel',show:false,istop:false
				},{
					id:7,name:'意见反馈',icon:'el-icon-chat-line-square',lk:'/msg',show:false,istop:false
				},{
					id:8,name:'提示词解析',icon:'el-icon-printer',lk:'/cc',show:false,istop:true
				},{
					id:9,name:'提示词管理',icon:'el-icon-reading',lk:'/cclist',show:false,istop:true
				},{
					id:10,name:'会员管理',icon:'el-icon-user',lk:'/userh',show:false,istop:true
				}]
			}
		},
		methods:{
			toRouter(data){
				this.$router.push(data.lk)
			},
			getMemberInfo() {
				let params = {
					token: api.getCookie('token')
				}
				api.getMemberInfo(params).then(res => {
					if (res.code == 200) {
						let lv = res.data.level;
						if(lv==6){
							this.navData[7].show = true;
							this.navData[8].show = true;
							this.navData[9].show = true;
						}
					}
				})
			},
			logout() {
				this.$confirm('确定要退出登录？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					api.delCookie('token');
					this.$router.push("/login");
				}).catch(() => {
			
				});
			},
		},
		mounted() {
			this.getMemberInfo();
			let path = this.$route.path;
			for(let i in this.navData){
				if(this.navData[i].lk == path){
					this.navIndex = this.navData[i].id;
				}
			}
		}
	}

</script>

<style>
	.user-logout{
		display: flex;
		position: absolute;
		bottom: 20px;
		background-color: var(--bg3);
		margin: 0 10%;
		width: 80%;
		padding: 12px 15px;
		font-size: 13px;
		border-radius: 10px;
		color: #666;
		box-sizing: border-box;
		cursor: default;
		justify-content: space-between;
	}
	.user-logout i{
		transform: rotate(90deg);
	}
	.user-logout:hover{
		background-color: var(--color);
		color: #fff;
	}
	.user-menu .unon{
		background-color: var(--bg3);
		border-left: 2px solid #0f5bff;
		color: #0f5bff;
		border-radius: 10px;
	}
	.user-menu dl:has(+ .unon){
		border-radius: 0 0 15px 0;
	}
	.user-menu .unon + dl{
		border-radius: 0 15px 0 0;
	}
	.user-nav dl dt{
		margin: 0;
	}
	.user-nav dl dd{
		margin: 0;
		padding-left: 10px;
	}
	.user-nav dl {
		display: flex;
		margin: 0;
		padding: 20px 12px 20px 38px;
		font-size: 14px;
		line-height: 16px;
		cursor: pointer;
		background-color: #fff;
		color: #333;
		border-left: 2px solid #fff;
	}
	
	.user-nav dl:hover{
		color: #000;
	}

	.user-menu {
		margin-top: 30px;
		margin-left: 16px;
		background-color: var(--bg3);
	}

	.user-logo img {
		display: block;
		height: 45px;
		margin: auto;
	}

	.user-logo {
		width: 100%;
		height: 45px;
		padding-top: 20px;
	}

	.user-nav {
		position: fixed;
		width: 220px;
		height: 100vh;
		left: 0;
		z-index: 99;
		top: 0;
		padding: 12px 0;
		box-sizing: border-box;
		background-color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/page/public/userMenu.vue